// @ts-nocheck
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../../../Helper/Permisstions/usePermissions';

import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';

const ListEmployees = ({ Employees }) => {
  const { HasPermission } = usePermissions();

  const [t, i18n] = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      <div className='table-responsive'>
        <table className='table w-100 mb-2  text-nowrap table-hover align-middle'>
          <colgroup>
            <col style={{ width: '50%' }} /> {/* عمود اسم الموظف */}
            <col style={{ width: '30%' }} /> {/* عمود الهوية */}
            <col style={{ width: '20%' }} /> {/* عمود الخيارات */}
          </colgroup>
          <tbody>
            {/* {[1, 2, 3, 1, 2, 3, 1].map((item, i) => ( */}
            {Employees.map((item, i) => {
              const orgName = i18n.language === 'ar' ? item.organizatioN_NAME2 : item.organizatioN_NAME;
              var jobName = i18n.language === 'ar' ? item.jobName2 : item.jobName;

              const isTerminated = item.endOfServiceDate !== null;

              return (
                <tr key={i} className='border-bottom'>
                  <td>
                    <div className='d-flex'>
                      <div className='position-relative mb-2'>
                        <img
                          src={
                            item?.personImage?.filePath ||
                            (item.gender === 'M'
                              ? '../../../assets/img/user/manEmp.png'
                              : '../../../assets/img/user/WomanEmp.png')
                          }
                          alt={t('EmployeeImage')}
                          className='w-80px h-65px'
                          loading='lazy'
                          style={{ objectFit: 'cover' }}
                          onError={e => {
                            e.target.onerror = null;
                            e.target.src =
                              item.gender === 'M'
                                ? '../../../assets/img/user/manEmp.png'
                                : '../../../assets/img/user/WomanEmp.png';
                          }}
                        />
                      </div>

                      <div className='flex-1 ps-3'>
                        <div className='fw-bold text-inverse d-flex justify-content-between'>
                          {i18n.language === 'en' ? item.name : item.name2}
                          {isTerminated && (
                            <span className='badge bg-danger pt-1'>
                              <i className='fas fa-user-slash me-2'></i>
                              {t('Terminated')}
                            </span>
                          )}
                        </div>
                        <div className=''>{item.nationalIdentifier}</div>
                        <div className=''>
                          <small className='fs-12px fw-bold lh-1 d-inline-block rounded-0 badge bg-theme bg-opacity-25 text-inverse  pt-5px'>
                            {item.employeeNumber}
                          </small>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <table className={'mb-3'}>
                      <tbody>
                        <tr>
                          <td className='pe-3'>{t('Organization')} :</td>
                          <td className='text-inverse text-opacity-75 fw-500'>
                            {item.organizatioN_ID !== null ? (
                              <h6>{orgName}</h6>
                            ) : (
                              <small className='fs-12px fw-bold lh-1 d-inline-block rounded-0 badge bg-warning bg-opacity-40 text-inverse  pt-5px'>
                                {t('NotAssigned')}
                              </small>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className='pe-3'>{t('Job')} :</td>
                          <td className='text-inverse text-opacity-75 fw-500'>
                            {item.organizatioN_ID !== null ? <h6>{jobName}</h6> : '---'}
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="pe-3">{t('EmployeeStatus')} :</td>
                          <td className="text-inverse text-opacity-75 fw-500">
                            {isTerminated ? (
                              <small className="fs-12px fw-bold lh-1 d-inline-block rounded-0 badge bg-danger bg-opacity-40 text-inverse  pt-5px">
                                {t('Terminated')}
                              </small>
                            ) : (
                              <small className="fs-12px fw-bold lh-1 d-inline-block rounded-0 badge bg-theme bg-opacity-40 text-inverse  pt-5px">
                                {t('Active')}
                              </small>
                            )}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </td>

                  <td className='text-end'>
                    <div className='action-buttons-wrapper'>
                      <Dropdown as={ButtonGroup} container='body'>
                        <Button className='btn-theme ' onClick={() => navigate(`${item.id}/Edit`)}>
                          {t('EmployeeDetails')}
                        </Button>

                        <Dropdown.Toggle className=' btn-theme ms-1' split />

                        <Dropdown.Menu renderMenuOnMount={true}>
                          {HasPermission('ExtraInformationHrPerson') && (
                            <Dropdown.Item
                              className='text-start'
                              onClick={() => {
                                navigate(`${item.id}/ExtraRecordFormPerson`);
                                localStorage.setItem('ReferenceName', JSON.stringify(item));
                              }}
                            >
                              <i className='fa fa-info-circle fa-fw me-2 text-theme'></i>
                              {t('extrarecord')}
                            </Dropdown.Item>
                          )}

                          {HasPermission('ViewdetailsHrPerAssignment') && (
                            <Dropdown.Item
                              className='text-start'
                              onClick={() =>
                                navigate(`${item.id}/Assignments`, {
                                  state: {
                                    ReferenceName: i18n.language === 'en' ? item.name : item.name2
                                  }
                                })
                              }
                            >
                              <i className='fa fa-clipboard-list fa-fw me-2 text-theme'></i>
                              {t('Assign')}
                            </Dropdown.Item>
                          )}

                          {/* {HasPermission('ViewlistHrPerAbsence') && (
                            <Dropdown.Item
                              className='text-start'
                              onClick={() =>
                                navigate(`absence/${item.id}`, {
                                  state: {
                                    ReferenceName: i18n.language === 'en' ? item.name : item.name2
                                  }
                                })
                              }
                            >
                              <i className='fa fa-calendar-times fa-fw me-2 text-theme'></i>
                              {t('Absence')}
                            </Dropdown.Item>
                          )} */}

                          {HasPermission('ViewlistHrPerAbsence') && (
                            <Dropdown.Item
                              className='text-start'
                              onClick={() =>
                                navigate(`AbsencesAndVacations/${item.id}`, {
                                  state: {
                                    ReferenceName: i18n.language === 'en' ? item.name : item.name2
                                  }
                                })
                              }
                            >
                              <i className='fa fa-calendar-times fa-fw me-2 text-theme'></i>
                              {t('Absences And Vacations')}
                            </Dropdown.Item>
                          )}
                          {HasPermission('AddPeriodOfService') && (
                            <Dropdown.Item
                              className='text-start'
                              onClick={() =>
                                navigate(`EndOfService/${item.id}`, {
                                  state: {
                                    ReferenceName: i18n.language === 'en' ? item.name : item.name2
                                  }
                                })
                              }
                            >
                              <i className='fa fa-user-slash  fa-fw me-2 text-theme '></i>
                              {t('EndOfService')}
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <style>
        {`
          /* إخفاء الزر بشكل افتراضي */
          .action-buttons-wrapper {
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          /* إظهار الزر عند مرور الماوس على الصف */
          tr:hover .action-buttons-wrapper {
            opacity: 1;
          }
          `}
      </style>
    </>
  );
};

export default memo(ListEmployees);
